export default "__VITE_ASSET__5a1a3c35__"